import { render } from "./time-selector.vue?vue&type=template&id=d980a646&scoped=true&ts=true"
import script from "./time-selector.vue?vue&type=script&lang=ts"
export * from "./time-selector.vue?vue&type=script&lang=ts"

import "./time-selector.vue?vue&type=style&index=0&id=d980a646&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d980a646"]])

export default __exports__